import _ from 'lodash';
import React from 'react';
import Moment from 'moment';
import PropTypes from 'prop-types';

import Button from '../../components/common/button/Button';
import Card from '../../components/common/card/Card';
import ErrorScreen from '../../components/derived/error/ErrorScreen';
import Carousel from '../../components/common/carousel/Carousel';
import FeaturedCard from '../../components/common/card/FeaturedCard';
import Spacer from '../../components/common/spacer/Spacer';
import Form from '../../components/common/form/Form';
import BookAnAppointment from '../../components/derived/modal/BookAnAppointment';
import FreeGiftCard from '../../components/derived/card/FreeGiftCard';

import Api from '../../../utils/api';
import TimeUtils from '../../../utils/time';

require('./style.scss');

const SVG_FILE_PATH = '../../../static/images/';
const DAY_OF_WEEK = _.toLower(Moment().format('dddd'));
const MAX_SERVICES = 2;
const MAX_PHOTOS = 5;


export default class Sidebar extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      code: null,
      contactNumbers: [],
      isStoreContactNumbersExpanded: false,
      isStoreTimingsExpanded: false,
      location: {},
      phoneNumber: null,
      services: [],
      storeName: null,
      timings: [],
      timingsToday: {},
      paymentModes: [],

      showServiceRequestModal: false,
      serviceRequestId: null,
      serviceRequestName: '',
      serviceRequestIcon: null,
    };
  }

  componentWillMount() {
    this.fetchSidebarData(this.props.profile);
  }

  componentWillReceiveProps(nextProps) {
    if ('profile' in nextProps) {
      this.fetchSidebarData(nextProps.profile);
    }
  }

  fetchSidebarData(profile) {
    this.setState({
      code: profile.code,
      contactNumbers: profile.contact_numbers,
      location: profile.address ? profile.address.location : {},
      paymentModes: profile.supported_payment_modes || [],
      phoneNumber: String(profile.phone_number),
      storeName: profile.store_name,
      timings: profile.timings,
      timingsToday: TimeUtils.timingsOnDay(profile.timings, DAY_OF_WEEK) || profile.general_timing,
    });

    if (profile.code) {
      Api.services(profile.code).then(services =>
        this.setState({ services: _.slice(services, 0, MAX_SERVICES) }));
    }
  }

  renderServiceCard(service) {
    return (
      <Card backgroundColor={service.background_color}>
        <Card.Content>
          <Card.Header
            media={<img role="presentation" src={`${SVG_FILE_PATH}home-delivery.svg`} />}
            title={service.name}
          />
          <Card.Body><p>{service.description}</p></Card.Body>
          <Card.Footer>
            <Form>
              <Button
                backgroundColor="#469154"
                label="Book an appointment"
                onClick={() => this.setState({
                  serviceRequestId: service.id,
                  serviceRequestName: service.name,
                  serviceRequestIcon: service.icon,
                  showServiceRequestModal: true,
                })}
                fullWidth
                extraPadding
              />
            </Form>
          </Card.Footer>
        </Card.Content>
      </Card>);
  }

  render() {
    const { profile } = this.props;

    const storeName = profile.store_name;
    const photos = _.slice(_.filter(
      profile.images, image => image.image_type === 'store-pic'), 0, MAX_PHOTOS);

    let paymentModeList = [];

    paymentModeList = this.state.paymentModes.filter((mode) => {
      if (mode.is_enabled === true) { return true; }
      return false;
    });

    return (
      <div id="sidebar">
        <div className="col-lg-7 col-md-7">
          <BookAnAppointment
            open={this.state.showServiceRequestModal}
            onClose={() => this.setState({ showServiceRequestModal: false })}
            code={this.state.code}
            serviceId={this.state.serviceRequestId}
            serviceName={this.state.serviceRequestName}
            serviceIcon={this.state.serviceRequestIcon}
          />

          <div id="payment">
            <div className="header">
              <img alt="payment" src={`${SVG_FILE_PATH}payment.svg`} />
              <h3>Payment Accepted</h3>
            </div>
            <div className="payment-modes">
              {paymentModeList.length ? paymentModeList.map((mode, i) => {
                if (i === paymentModeList.length - 1) {
                  return <h4 key={mode.name}>{mode.name}</h4>;
                }
                return <h4 key={mode.name}>{mode.name}{',  '}</h4>;
              }) : <h4>Cash</h4>}
            </div>
          </div>

          <Spacer size={2} />

          <FeaturedCard id="photos">
            <FeaturedCard.Content>
              <FeaturedCard.Header
                actions={
                  <Button
                    link={`/${this.props.params.partnerSlug}/photos`}
                    color="#ffffff"
                    label="View All"
                  />}
                title={<h4>Store Images</h4>}
                media={<img role="presentation" src={`${SVG_FILE_PATH}store-image.svg`} />}
                backgroundColor="#0084FF"
                color="#ffffff"
              />

              <FeaturedCard.Body>
                {_.size(photos) > 0 ?
                  <Carousel slideWidth={200} autoplay>
                    {_.map(photos, image =>
                      <Carousel.Slide key={image.id}>
                        <img role="presentation" src={image.image_thumbnail} />
                      </Carousel.Slide>)}
                  </Carousel> :
                  <span>
                    <ErrorScreen
                      compact
                      media={<img role="presentation" src={`${SVG_FILE_PATH}no-Photos.png`} />}
                      title="Photos are not updated yet"
                      helpText={`Stay updated with ${storeName}<br />` +
                        'through m.Paani Shop Smart App'}
                    />
                  </span>}
              </FeaturedCard.Body>
            </FeaturedCard.Content>
          </FeaturedCard>

          <Spacer size={2} />

          {_.map(this.state.services, service =>
            <span key={service.id}>
              {this.renderServiceCard(service)}
              <Spacer size={2} />
            </span>)}

          <div className="become-member"><FreeGiftCard storeName={this.state.storeName} alternate title="Become a Member" /></div>

          <Spacer size={2} />

          <Card>
            <Card.Content>
              <Card.Header
                media={<img role="presentation" src={`${SVG_FILE_PATH}download.svg`} />}
                title="Download Our App"
              />
              <Card.Body>
                <a
                  href="https://play.google.com/store/apps/details?id=chotelal.mpaani.com.android.chotelal"
                  rel="noreferrer noopener"
                  target="_blank"
                >
                  <img alt="Play Store" src="/static/images/app_download_icon.png" />
                </a>
              </Card.Body>
            </Card.Content>
          </Card>

          <Spacer size={2} />

        </div>
      </div>);
  }
}

Sidebar.renderServiceCard = service =>
  <Card backgroundColor={service.background_color}>
    <Card.Media icon={<img alt={service.name} src={service.icon} />} />
    <Card.Content>
      <Card.Header title={service.name} />
      <Card.Body>{service.description}</Card.Body>
      <Card.Footer>
        <Form>
          <Button
            backgroundColor="#469154"
            label="Book an appointment"
            fullWidth
            extraPadding
          />
        </Form>
      </Card.Footer>
    </Card.Content>
  </Card>;

Sidebar.propTypes = {
  params: PropTypes.shape({
    partnerSlug: PropTypes.string,
  }),
};

module.exports = Sidebar;



// WEBPACK FOOTER //
// ./app/layouts/sidebar/Sidebar.jsx